(function () {
  const MOBILE_QUERY = window.matchMedia('(max-width: 749px)');
  const TOOLTIP_WIDTH_RATIO = 0.9;
  const VIEWPORT_MARGIN = 12;
  const GAP = 10;

  function isMobile() {
    return MOBILE_QUERY.matches;
  }

  function getTooltip(trigger) {
    return trigger._vennassaTooltip || trigger.querySelector('.vennassa-variant-info__tooltip');
  }

  function restoreTooltip(trigger) {
    const tooltip = getTooltip(trigger);
    if (!tooltip || !trigger._vennassaTooltipPlaceholder) return;

    trigger._vennassaTooltipPlaceholder.parentNode.insertBefore(
      tooltip,
      trigger._vennassaTooltipPlaceholder
    );
    trigger._vennassaTooltipPlaceholder.remove();
    trigger._vennassaTooltipPlaceholder = null;
    tooltip.style.cssText = '';
    tooltip.classList.remove('is-below');
  }

  function closeAll() {
    document.querySelectorAll('.vennassa-variant-info.is-tooltip-open').forEach(function (trigger) {
      trigger.classList.remove('is-tooltip-open');
      trigger.setAttribute('aria-expanded', 'false');
      restoreTooltip(trigger);
    });
  }

  function moveTooltipToBody(trigger, tooltip) {
    if (tooltip.parentNode === document.body) return;

    const placeholder = document.createComment('vennassa-tooltip');
    trigger.insertBefore(placeholder, tooltip);
    trigger._vennassaTooltipPlaceholder = placeholder;
    trigger._vennassaTooltip = tooltip;
    document.body.appendChild(tooltip);
  }

  function positionTooltip(trigger, tooltip) {
    moveTooltipToBody(trigger, tooltip);

    const viewportWidth = window.innerWidth;
    const boxWidth = viewportWidth * TOOLTIP_WIDTH_RATIO;
    const left = (viewportWidth - boxWidth) / 2;

    tooltip.style.position = 'fixed';
    tooltip.style.left = left + 'px';
    tooltip.style.right = 'auto';
    tooltip.style.width = boxWidth + 'px';
    tooltip.style.maxWidth = '90vw';
    tooltip.style.boxSizing = 'border-box';
    tooltip.style.transform = 'none';
    tooltip.style.bottom = 'auto';
    tooltip.style.margin = '0';
    tooltip.style.zIndex = '10001';

    tooltip.style.visibility = 'hidden';
    tooltip.style.opacity = '1';

    const triggerRect = trigger.getBoundingClientRect();
    const tooltipHeight = tooltip.offsetHeight;
    let top = triggerRect.top - GAP - tooltipHeight;

    tooltip.classList.remove('is-below');

    if (top < VIEWPORT_MARGIN) {
      top = triggerRect.bottom + GAP;
      tooltip.classList.add('is-below');
    }

    tooltip.style.top = Math.max(VIEWPORT_MARGIN, top) + 'px';
    tooltip.style.visibility = 'visible';
  }

  function openTooltip(trigger) {
    const tooltip = getTooltip(trigger);
    if (!tooltip) return;

    closeAll();
    trigger.classList.add('is-tooltip-open');
    trigger.setAttribute('aria-expanded', 'true');
    positionTooltip(trigger, tooltip);
  }

  function toggleTooltip(trigger) {
    if (trigger.classList.contains('is-tooltip-open')) {
      closeAll();
      return;
    }
    openTooltip(trigger);
  }

  document.addEventListener(
    'click',
    function (event) {
      if (!isMobile()) return;

      const trigger = event.target.closest('.vennassa-variant-info');
      if (trigger) {
        event.preventDefault();
        event.stopPropagation();
        toggleTooltip(trigger);
        return;
      }

      if (!event.target.closest('.vennassa-variant-info__tooltip')) {
        closeAll();
      }
    },
    true
  );

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAll();
  });

  window.addEventListener('resize', function () {
    if (!isMobile()) {
      closeAll();
      return;
    }

    const openTrigger = document.querySelector('.vennassa-variant-info.is-tooltip-open');
    if (openTrigger) {
      const tooltip = getTooltip(openTrigger);
      if (tooltip) positionTooltip(openTrigger, tooltip);
    }
  });

  MOBILE_QUERY.addEventListener('change', function () {
    closeAll();
  });

  document.addEventListener('shopify:section:load', closeAll);
})();
